<template>
    <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
        <div style="padding:0px;width:100%;">
            <div class="whiteBox dashboard_topic">
                <div class="portlet-title">
                    <i class="el-icon-d-arrow-right">&nbsp;</i>王朝线索跟进统计表
                </div>
                <div class="portlet-content">
                    <!-- 搜索区：参照厂端 clue-follow-statistics 搜索字段，去除经销商级联/省份/城市（单店登录） -->
                    <div class="filter-container" style="padding-top: 0px;">
                        <el-date-picker
                            size="mini"
                            v-model="listQuery.dateRange"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="客户创建开始日期"
                            end-placeholder="客户创建结束日期"
                            :clearable="false"
                            :picker-options="datePickerOption">
                        </el-date-picker>

                        <el-button class="filter-item" size="mini" type="info" icon="el-icon-search" @click="doSearch">查询</el-button>
                        <el-button class="filter-item" size="mini" icon="el-icon-refresh" @click="doReset">重置</el-button>
                        <!-- <el-button class="filter-item" size="mini" icon="el-icon-download" @click="doExport">导出</el-button> -->
                    </div>

                    <!-- 统计表：单店视角，去除战区/大区/区域/省份/城市/经销商名称/代码列，保留指标列 -->
                    <el-table :data="list" stripe id="table" v-loading="listLoading">
                        <el-table-column prop="name" label="经销商名称" min-width="130">
                        </el-table-column>
                        <el-table-column prop="code" label="经销商代码" width="110">
                        </el-table-column>
                        <el-table-column prop="validCount" label="有效线索数" width="120">
                            <template slot="header" slot-scope="scope">
                                有效线索数
                                <el-popover placement="top-start" width="300" trigger="hover">
                                    <div>有效线索数=线上有效线索数+线下有效线索数；</div>
                                    <div>线上有效线索数：统计线索关联客档手机号长度大于2，且线索状态为指定范围内的线上线索总数（待分配、正在跟进、战败、订车、交车、休眠、等待跟进）;</div>
                                    <div>线下有效线索数：统计客档手机号长度大于2的线下线索（客档）总数；</div>
                                    <i class="fa fa-question-circle-o" aria-hidden="true" slot="reference"></i>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="firstFollowCount" label="首次跟进期间合格跟进数" width="160">
                        </el-table-column>
                        <el-table-column prop="nightValidCount" label="非工作时间有效线索数" width="150">
                        </el-table-column>
                        <el-table-column prop="secondFollowCount" label="二次跟进期间合格跟进数" width="160">
                        </el-table-column>
                        <el-table-column prop="thirdFollowCount" label="三次跟进期间合格跟进数" width="160">
                        </el-table-column>
                        <el-table-column prop="threeFollowCount" label="三次跟进均合格数" width="130">
                        </el-table-column>
                        <el-table-column prop="averageClearSecond" label="平均清洗时长" width="120">
                            <template slot-scope="scope">
                                {{ (scope.row.averageClearSecond === null || scope.row.averageClearSecond === undefined || scope.row.averageClearSecond === '') ? '--' : `${scope.row.averageClearSecond}s` }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="averageClearPassRate" label="线索清洗合格率" width="130">
                            <template slot-scope="scope">
                                {{ formatPassRate(scope.row.averageClearPassRate) }}
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="pagination-container">
                        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="listQuery.page" :page-sizes="[10,20,30,50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';

// 查询条件初始值（重置时恢复）：默认查近30天
const initListQuery = {
    dateRange: [dayjs().subtract(30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')], // 客户创建时间范围
    page: 1,
    limit: 10,
};

export default {
    data() {
        return {
            dealer: this.$common.getDealer(),
            list: [],
            total: 0,
            listLoading: false,
            listQuery: Object.assign({}, initListQuery),
            datePickerOption: {
                firstDayOfWeek: 1,
            },
        };
    },
    mounted() {
        this.doSearch();
    },
    methods: {
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.doSearch();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.doSearch();
        },
        doSearch() {
            // 边界1：时间范围为空时不发起请求
            if (!this.listQuery.dateRange || this.listQuery.dateRange.length !== 2) {
                this.$message.warning('为保证数据查询准确，客户创建时间必选一个时间范围。');
                return;
            }
            // 边界2：时间范围超过180天时提示并终止
            if (dayjs(this.listQuery.dateRange[1]).diff(this.listQuery.dateRange[0], 'day') > 180) {
                this.$message.warning('时间范围不能超过180天！');
                return;
            }
            this.listLoading = true;
            this.list = [];
            this.$httpAuth
                .post("/v2/v2DealerReportRpc/customerFollowSummary", {
                    ...this.getParams(),
                    pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
                    pageCount: this.listQuery.limit,
                    isExport: false,
                })
                .then((response) => {
                    // 边界3：接口无数据时兜底为空列表，避免表格报错
                    const data = response.data || {};
                    this.list = data.data || [];
                    this.total = data.total || 0;
                    this.listLoading = false;
                })
                .catch(() => {
                    // 边界4：请求异常时关闭 loading 并置空列表
                    this.listLoading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        doReset() {
            this.list = [];
            this.total = 0;
            this.listLoading = false;
            this.listQuery = Object.assign({}, initListQuery);
            this.doSearch();
        },
        doExport() {
            if (!this.listQuery.dateRange || this.listQuery.dateRange.length !== 2) {
                this.$message.warning('为保证数据查询准确，客户创建时间必选一个时间范围。');
                return;
            }
            if (dayjs(this.listQuery.dateRange[1]).diff(this.listQuery.dateRange[0], 'day') > 180) {
                this.$message.warning('时间范围不能超过180天！');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: '正在导出中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$httpAuth
                .post("/v2/v2DealerReportRpc/customerFollowSummary", { ...this.getParams(), isExport: true })
                .then((response) => {
                    const { File, total } = response.data
                    if (total > 2000) {
                        this.$message({
                            customClass: 'export-message',
                            dangerouslyUseHTMLString: true,
                            message: '<div>应安全要求，一次性最多只能导出2000条数据</div>',
                            duration: 2000
                        });
                    }
                    setTimeout(() => {
                        loading.close()
                        let a = document.createElement('a');
                        a.href = File;
                        a.click();
                    }, 1000);
                })
                .catch(() => {
                    loading.close()
                });
        },
        /**
     * 清洗合格率格式化：接口返回小数（如 0.8562），转换为百分比展示
     * @param {Number|String} rate - 小数比率
     * @returns {String} 百分比字符串（如 85.62%），空值/非法值返回 '--'
     */
    formatPassRate(rate) {
        // 边界1：空值直接返回占位符
        if (rate === null || rate === undefined || rate === '') {
            return '--';
        }
        const num = Number(rate);
        // 边界2：非数字（如后端返回文本）返回占位符
        if (isNaN(num)) {
            return '--';
        }
        // 边界3：乘100转百分比，保留两位小数并去除尾随零（85.00% -> 85%）
        return `${parseFloat((num * 100).toFixed(2))}%`;
    },
    getParams() {
            const { dateRange } = this.listQuery;
            // 时间转换为 00:00:00 ~ 23:59:59 的秒级时间戳；范围为空时传 null
            const dateStart = dateRange && dateRange.length === 2
                ? dayjs(`${dateRange[0]} 00:00:00`).unix()
                : null;
            const dateEnd = dateRange && dateRange.length === 2
                ? dayjs(`${dateRange[1]} 23:59:59`).unix()
                : null;
            return {
                dealerId: this.dealer.dealerId,
                startDate: dateStart, // 客户创建开始时间
                endDate: dateEnd, // 客户创建结束时间
            };
        },
    },
};
</script>

<style>

</style>
